/**
 * Contructor
 */
const config = {};

/**
 * Development configurations
 */
config.development = {
  TOKEN: {
    UNIT: 'KAT',
    ADDRESS: '0x9dddff7752e1714c99edf940ae834f0d57d68546',
    DECIMALS: 18
  },
  REDEEMER: {
    ADDRESS: '0xaf2c0F86a2d11816d04Ad847CE0AebC98CA0424F'
  },
  NETWORK: {
    ID: 4,
    LABEL: 'Rinkeby'
  },
  EVENTS: {
    TRANSFER: 'Transfer'
  }
};

/**
 * Staging configurations
 */
config.staging = {
  TOKEN: {
    UNIT: 'KAT',
    ADDRESS: '0x9dddff7752e1714c99edf940ae834f0d57d68546',
    DECIMALS: 18
  },
  REDEEMER: {
    ADDRESS: '0xaf2c0F86a2d11816d04Ad847CE0AebC98CA0424F'
  },
  NETWORK: {
    ID: 4,
    LABEL: 'Rinkeby'
  },
  EVENTS: {
    TRANSFER: 'Transfer'
  }
};

/**
 * Production configurations
 */
config.production = {
  TOKEN: {
    UNIT: 'KAT',
    ADDRESS: '0x14da230d6726c50f759bc1838717f8ce6373509c',
    DECIMALS: 18
  },
  REDEEMER: {
    ADDRESS: '0x5bd69d5b519e7cd65c20d6b7c51e7deda0b3b36f'
  },
  NETWORK: {
    ID: 1,
    LABEL: 'Mainnet'
  },
  EVENTS: {
    TRANSFER: 'Transfer'
  }
};

/**
 * Module exports
 */
export default config;
